// Copyright (c) 2018 Deere & Company

export const getExcelLayoutListId = searchByType =>
    searchByType === 'PIN' ?
        'pipProductSearch' :
        'pipSearch';



// WEBPACK FOOTER //
// ./src/pip/pip-search/services/get-excel-layout-list-id.js